import Vue from 'vue';
Vue.config.devtools = true;

export default function () {
  const fileInputs = document.querySelectorAll('input[type="file"]');

  if (!fileInputs.length) {
    return;
  }

  const imageInput = new Vue({
    el: '#js-file-input',
    data: {
      image: ''
    },
    methods: {
      onFileChange(e) {
        let files = e.target.files || e.dataTransfer.files;
        let fileName = e.target.value.split('\\').pop();

        if (!files.length) {
          return;
        }

        if (fileName) {
          document.querySelector('label[for="' + e.target.id + '"]').innerHTML = fileName;
        }
      }
    }
  });
};

